import PromotionSpecific from './promotion-specific'

export default PromotionSpecific;
